import { ActionContext } from 'vuex';
import { IPurchaseResponse } from '@/interfaces/Purchase';

import { IBehavior } from '@/interfaces/Behavior';

import { generateUUID } from '@/helpers/ab';

export default {
  setOfferLoaded({ commit }: ActionContext<{}, any>, offerHash: string) {
    commit('setOfferLoaded', offerHash);
  },
  setCaptchaValid({ commit }: ActionContext<{}, any>, isCaptchaValid: boolean) {
    commit('setCaptchaValid', isCaptchaValid);
  },
  setPurchaseResponse ({ commit }: ActionContext<{}, any>, purchaseResponse: IPurchaseResponse) {
    commit('setPurchaseResponse', purchaseResponse);
  },
  setUUID ({ commit, getters }: ActionContext<IBehavior, any>) {
    const uuid = generateUUID();

    if (getters['uuid']) {
      return getters['uuid'];
    }

    commit('setUUID', uuid);

    return uuid;
  },
  disablePay ({ commit }: ActionContext<IBehavior, any>) {
    commit('disablePay');
  },
};
